module.exports = __webpack_public_path__ + "img/binding_width.d8e32efb.png";